import { ReviewsChapter } from '@/entities/catalog-inside-page/ReviewsChapter/ui/ReviewsChapter.jsx'
import './ui/ReviewsChapter.scss'
export default ReviewsChapter
